import request from './request'

export const homeApi = {
  //获取导航列表
  getNavList(params){
     return request({
      url: '/admin-api/website/nav/list',
      method: 'get',
      params
    })
  },

  //获取首页轮播图
  getSwiperList(params){
    return request({
        url: '/admin-api/website/swiper/list',
        method: 'get',
        params
    })
  },


  //获取公告列表
  getNoticeList(params){
    return request({
        url: '/admin-api/website/notice/list',
        method: 'get',
        params
    })
  },

  //获取焦点新闻、莘莘学子等数据
  getArticleList(params){
     return request({
      url: '/admin-api/website/categories/list',
      method: 'get',
      params
    })
  },
  //获取视频
  getvideo(params){
     return request({
      url: '/admin-api/website/video/list',
      method: 'get',
      params
    })
  },

  //获取全站是否置灰配置

  getGary(params){
     return request({
      url: '/admin-api/website/setting/get',
      method: 'get',
      params
    })
  },
}


export const subApi = {

  //获取二级页面数据
  getNavList(params){
     return request({
      url: '/admin-api/website/categories/get',
      method: 'get',
      params
    })
  },
    //获取二级页面点击更多数据
  getSubArticleList(params){
     return request({
      url: '/admin-api/website/article/query',
      method: 'get',
      params
    })
  },

     //获取视频页面数据
  getVideoList(videoId){
     return request({
      url: '/admin-api/website/video/topic/'+videoId,
      method: 'get',
      
    })
  },

     //获取文章详情
  getArticleDetail(id){
     return request({
      url: '/admin-api/website/article/get?id='+id,
      method: 'get',
      
    })
  },


   //文章浏览数接口
  getArticleCount(id){
     return request({
      url: '/admin-api/website/article/view-count?id='+id,
      method: 'get',
      
    })
  },

     //s搜索接口
  getSearch(params){
     return request({
      url: '/admin-api/website/article/page',
      method: 'get',
      params
      
    })
  },

  getArticleNavList(id){
      return request({
          url: '/admin-api/website/article/nav?id='+id,
          method: 'get',
      })
  }

}